import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import { MainRecommendedItemRow } from '@models/item/recommendedItem';
import { Link } from '@router/Link';

import styles from './styles.module.scss';

interface Props {
    item: MainRecommendedItemRow;
}

function RecommendationItem({ item }:Props) {
  const {
    name, salePrice, basePrice, thumbnailUrl,
  } = item;
  return (
      <Link activityName='ShopListActivity'
            activityParams={{
              originalItemId: item.itemId,
              type: 'LIST',
              isOrder: true,
            }}>
          <Column spacing={5}
                  fullWidth
                  className={styles.container} >
              <Image src={thumbnailUrl}
                     className={styles.thumbnail}
                     width={118}
                     height={118}
                     alt='음료' />
              <Column fullWidth
                      align='center' >
                  <Text className={styles.name} align='center'>
                      {name}
                  </Text>
                  <Row spacing={3} align='center'>
                      {basePrice !== salePrice && (
                          <Text color={colors.gray6} size='s'>
                              {basePrice.toLocaleString()}원
                          </Text>
                      )}
                      <Text fontWeight='bold' size='s' className={styles.price}>
                          {salePrice.toLocaleString()}원
                      </Text>
                  </Row>
              </Column>
          </Column>
      </Link>
  );
}
export default RecommendationItem;
